import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'OneDeskHeroModule',
    props: {
        for: {}
    },
    setup(__props) {
        const props = __props;
        const className = computed(() => {
            const res = "hero-module-wrapper";
            switch (props.for) {
                case "inventory":
                    return res + " inventory-hero-module";
                case "details":
                    return res + " details-hero-module";
                default:
                    return res;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(className.value)
            }, [
                _renderSlot(_ctx.$slots, "content")
            ], 2));
        };
    }
});
